/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "common": {
                "nested": {
                  "OrderSource": {
                    "values": {
                      "SHOP_2X_WEB": 1,
                      "API_GROWTH_WEB": 2,
                      "API_GROWTH_MOBILE": 3,
                      "SUB2": 4
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.common?.nested?.OrderSource) {
	$root.addJSON(jsonData);
}

/**
 * The full list of order sources live here https://github.com/squareup/solidshop/blob/main/app/models/sq/orders/source.rb
 *
 * SOURCE OrderSource @ squareup/solidshop/v2/common/order_source.proto at 9:1
 */
export const OrderSource = $root.lookupEnum('squareup.solidshop.v2.common.OrderSource').values;
